module.exports = __webpack_public_path__ + "static/media/stock-3.257f5bc0.jpg";